'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SpinButton = require('../generic/SpinButton');

var _SpinButton2 = _interopRequireDefault(_SpinButton);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Helpers             from '../helpers';


var NO_ADDRESS_MSG = "You have not saved any delivery address.";
var DELIVERY_NOT_AVAILABLE_MSG = "Pick Up only. Delivery is not available.";
var DELIVERY_OUTSIDE_RANGE_MESSAGE = "Delivery is not available for this address, it is outside our delivery zone.";
var DELIVERY_FEE_NOT_SELECTED = "Delivery fee may vary according to the address.";
var DELIVERY_FEE_SELECTED = "Based on the address, delivery fee is ";

var Address = function (_React$Component) {
    _inherits(Address, _React$Component);

    function Address(props) {
        _classCallCheck(this, Address);

        var _this = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this, props));

        _this.clearCartDeliveryCalculations = function () {
            _ScheduleScreenStore2.default.setDeliveryDistance(0);
            _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(0);
            _ScheduleScreenStore2.default.setDeliveryFee(0);
            _ScheduleScreenStore2.default.setDeliveryFeeType('');
        };

        _this.setFailureState = function () {
            _this.setState({
                selectedDeliveryAddressIdx: '',
                isSelectedAddressValidated: false,
                isInvalidAddress: true,
                isAddressListCompEnabled: true
                // addAddressObj : {}
            }, function () {
                _this.props.handleAddressChange({});
            });
        };

        _this.setSuccessState = function () {
            _this.setState({
                isSelectedAddressValidated: true,
                isInvalidAddress: false,
                isAddressListCompEnabled: false
            }, function () {

                _this.props.handleAddressChange(_this.state.addAddressObj);
            });
        };

        _this.calculateDistances = function (deliveryAddress) {

            // if the selected delivery address is empty then show the error
            if (Utils.isEmptyObj(deliveryAddress)) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            }

            // get deliveryInfo object value
            var isDeliveryCoordinates = _CartStore2.default.getDeliveryCoordinates();
            var deliveryAddressStr = Utils.getDeliveryAddressSearchStr(deliveryAddress);
            if (isDeliveryCoordinates != null) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': deliveryAddressStr
                }, _this.callBackDeliveryCoordinates);
            } else {
                _this.getAddressDistance(deliveryAddressStr);
            }
        };

        _this.callBackDeliveryCoordinates = function (response, status) {
            if (status != google.maps.DistanceMatrixStatus.OK) {
                document.getElementById('autocomplete').value = "";
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            } else {
                // Address string
                var deliveryAddressString = response[0].formatted_address;

                // delivery address lat & long
                var deliveryAddressCoordinates = response[0].geometry.location;

                // Location details object
                var locationDetail = _CartStore2.default.getLocationDetail();

                var origin = void 0;
                if (locationDetail.location) {
                    origin = {
                        lat: locationDetail.location.latitude,
                        lng: locationDetail.location.longitude
                    };
                } else {
                    origin = Utils.getAddressSearchStrFromLocation(locationDetail);
                }

                // get delivery maps coordinates
                var deliveryMapCoordinates = _CartStore2.default.getDeliveryCoordinates();

                // check address inside the polygon map or not
                var checkInPolygon = _this.checkInPolygon(deliveryAddressCoordinates, deliveryMapCoordinates, origin);

                if (checkInPolygon != true) {
                    document.getElementById('autocomplete').value = "";
                    //hide schedule Modal befoe
                    //opening schedule modal
                    _this.props.callBackParent();

                    _sweetalert2.default.fire({
                        title: 'Outside of Delivery Range',
                        text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        customClass: {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        },
                        allowOutsideClick: false
                    }).then(function (result) {
                        if (result.isDismissed) {
                            var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                            if (scheduleOrderModal) {
                                scheduleOrderModal.style.display = "block";
                            }
                        }
                    });

                    _this.clearCartDeliveryCalculations();
                    _this.setFailureState();
                    return;
                } else {
                    // call the function and get address distance
                    _this.getAddressDistance(deliveryAddressString);
                }
            }
        };

        _this.checkInPolygon = function (addressCoordinates, letlongCoords, locationCenter) {
            var map = new google.maps.Map(document.getElementById("map_canvas"), {
                center: locationCenter
                // center: new google.maps.LatLng(37.4419, -122.1419),
            });

            var bermudaTriangle = new google.maps.Polygon({
                map: map,
                paths: letlongCoords
            });

            // address inside the polygon or not
            if (google.maps.geometry.poly.containsLocation(addressCoordinates, bermudaTriangle)) {
                return true;
            } else {
                return false;
            }
        };

        _this.callback = function (response, status) {

            if (status != google.maps.DistanceMatrixStatus.OK) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            } else {

                var locationDetail = _CartStore2.default.getLocationDetail();

                var routes = response.rows[0];

                var lowestDistance = Number.POSITIVE_INFINITY;
                var resultText = "Possible Routes:";
                var tmp = void 0;
                var shortestRouteIdx = void 0;

                // get deliveryInfo object value
                var locationDeliveryInfo = _CartStore2.default.getDeliveryInfo();

                for (var i = routes.elements.length - 1; i >= 0; i--) {

                    if (routes.elements[i].distance) {
                        tmp = routes.elements[i].distance.value;
                        resultText += "Route " + ": " + routes.elements[i].distance.text + "";
                    }
                    if (tmp < lowestDistance) {
                        lowestDistance = tmp;
                        shortestRouteIdx = i;
                    }
                }

                if (lowestDistance == null || lowestDistance == Number.POSITIVE_INFINITY) {
                    //hide schedule Modal befoe
                    //opening schedule modal
                    _this.props.callBackParent();

                    _sweetalert2.default.fire({
                        title: 'Error!',
                        text: 'Selected address distance can not be calculated accurately. Either choose Pick Up option or call Restaurant at ' + Utils.formatPhoneNumber(locationDetail.phoneNumber) + ' to check if they can deliver.',
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        customClass: {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        },
                        allowOutsideClick: false
                    }).then(function (result) {
                        if (result.isDismissed) {
                            var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                            if (scheduleOrderModal) {
                                scheduleOrderModal.style.display = "block";
                            }
                        }
                    });

                    document.getElementById('autocomplete').value = "";
                    _this.clearCartDeliveryCalculations();
                    _this.setFailureState();
                    return;
                }

                // get the discounted total amount
                // let orderTotalAmount = CartStore.getCartSubTotalWithDiscountAbs();

                // distance in miles
                var distanceInMiles = Utils.getMeterInMiles(lowestDistance);
                // distance in meter
                var distanceInMeter = lowestDistance;

                // check if the deliveryInfo exist or not
                if (locationDeliveryInfo) {
                    // const minAmount = Utils.extractWebsiteConfig(locationDeliveryInfo, "minAmount");
                    var deliveryFeeType = Utils.extractWebsiteConfig(locationDeliveryInfo, "feeType");

                    // get the delivery distance in meters
                    var maxRange = _CartStore2.default.getMaxDeliveryDistanceInMeters();

                    if (lowestDistance > maxRange) {

                        //hide schedule Modal befoe
                        //opening schedule modal
                        _this.props.callBackParent();

                        _sweetalert2.default.fire({
                            title: 'Outside of Delivery Range',
                            text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close',
                            customClass: {
                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                            },
                            allowOutsideClick: false
                        }).then(function (result) {
                            if (result.isDismissed) {
                                var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                                scheduleOrderModal.style.display = "block";
                            }
                        });

                        document.getElementById('autocomplete').value = "";
                        // this.props.dispatch(scheduleScreenActions.addLine1(""));
                        _this.clearCartDeliveryCalculations();
                        _this.setFailureState();
                        return;
                    }

                    _ScheduleScreenStore2.default.setDeliveryDistance(distanceInMiles);
                    _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(distanceInMeter);
                    _ScheduleScreenStore2.default.setDeliveryFeeType(deliveryFeeType);

                    _this.setSuccessState();
                    // Pass the success data to parent class

                } else {
                    var deliveryFees = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "fee");
                    var _deliveryFeeType = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "feeType");
                    // const minAmount = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "minAmount");

                    var rangeMap = Utils.getDeliveryRange(deliveryFees);

                    var range = Object.keys(rangeMap);
                    var _maxRange = range[range.length - 1];
                    var maxRangeInMeters = Utils.convertMilesInMeters(_maxRange);

                    if (lowestDistance > maxRangeInMeters) {
                        document.getElementById('autocomplete').value = "";
                        //hide schedule Modal befoe
                        //opening schedule modal
                        _this.props.callBackParent();

                        _sweetalert2.default.fire({
                            title: 'Outside of Delivery Range',
                            text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close',
                            customClass: {
                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                            },
                            allowOutsideClick: false
                        }).then(function (result) {
                            if (result.isDismissed) {
                                var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                                if (scheduleOrderModal) {
                                    scheduleOrderModal.style.display = "block";
                                }
                            }
                        });

                        _this.clearCartDeliveryCalculations();
                        _this.setFailureState();
                        return;
                    }

                    // call a function to calculate the delivery fee charges
                    // deliveryFee = CartStore.getDeliveryConfigFee(distanceInMiles, rangeMap, orderTotalAmount);


                    _ScheduleScreenStore2.default.setDeliveryDistance(distanceInMiles);
                    _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(distanceInMeter);
                    // CartStore.setDeliveryFee(deliveryFee);
                    _ScheduleScreenStore2.default.setDeliveryFeeType(_deliveryFeeType);

                    _this.setSuccessState();
                }
            }
        };

        _this.changePhoneNumber = function (e) {
            // this is where we'll call the phoneNumberFormatter function
            var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(e.target.value);
            _this.state.addAddressObj.phoneNumber = formattedPhoneNumber;

            _this.setState({
                addAddressObj: _this.state.addAddressObj
            }, function () {

                if (!Utils.isEmptyObj(_this.state.addAddressObj) && !Utils.isEmpty(_this.state.addAddressObj.phoneNumber)) {
                    _this.props.handleAddressChange(_this.state.addAddressObj);
                }
            });
        };

        _this.state = _this.initialState();
        _this.fillInAddress = _this.fillInAddress.bind(_this);
        _this.changeName = _this.changeName.bind(_this);
        _this.changePhoneNumber = _this.changePhoneNumber.bind(_this);
        // this.handleSubmit = this.handleSubmit.bind(this);
        _this.changeAddressLine2 = _this.changeAddressLine2.bind(_this);
        _this.addInputFieldChange = _this.addInputFieldChange.bind(_this);
        _this.autocomplete = null;
        return _this;
    }

    _createClass(Address, [{
        key: 'initialState',
        value: function initialState() {
            return {
                // orderType:  ScheduleScreenStore.getCurrentOrderType(),
                addAddressObj: {
                    name: '',
                    phoneNumber: '',
                    addLine1: '',
                    addLine2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    country: ''
                },
                buttonText: 'Save Address',
                isAddressBeingAdd: false,
                validateAdd: false,
                //delivery add
                addressContainer: [],
                deliveryDistances: [],
                shortestRouteIdx: 0,
                selectedDeliveryAddressIdx: '',
                isAddressListCompEnabled: true,
                isSelectedAddressValidated: false,
                isInvalidAddress: true,
                typingTimeout: ""
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var activeLocation = _MainStore2.default.getActiveLocation();
            var defaultCountry = activeLocation.country ? activeLocation.country : "US";

            // Initialized the AutoComplete
            this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
                componentRestrictions: { country: [defaultCountry] },
                fields: ["address_components", "geometry"],
                types: ["address"]
                // types: ['geocode'],
                // bounds:  cityBounds,
                // strictBounds: true,
            });

            this.autocomplete.addListener("place_changed", this.fillInAddress);

            $('#' + this.props.modalId).on("scroll", function () {
                // console.log("Scrolling");
                var isVisible = $('.pac-container').is(':visible');
                if (isVisible) {
                    $('.pac-container').hide();
                }
            });

            document.getElementById("autocomplete").addEventListener("input", this.addInputFieldChange);

            var deliveryAddressObj = _lodash2.default.cloneDeep(_CartStore2.default.getDeliveryAddress());
            var isSavedAddressActive = _ScheduleScreenStore2.default.getSavedAddressActive();

            if (!Utils.isEmptyObj(deliveryAddressObj) && !isSavedAddressActive) {
                var formattedPhoneNumber = Utils.convertStringToPhoneNumberFormat(deliveryAddressObj.phoneNumber);
                deliveryAddressObj.phoneNumber = formattedPhoneNumber;

                this.setState({
                    addAddressObj: deliveryAddressObj
                }, function () {
                    _this2.props.handleAddressChange(_this2.state.addAddressObj);
                    if (deliveryAddressObj.addLine1 !== undefined) {
                        document.getElementById("autocomplete").value = deliveryAddressObj.addLine1 + ' ' + deliveryAddressObj.city + ' ' + deliveryAddressObj.state + ' ' + deliveryAddressObj.zipCode;
                    }
                });
            } else {
                this.setState({
                    addAddressObj: {
                        name: '',
                        phoneNumber: '',
                        addLine1: '',
                        addLine2: '',
                        city: '',
                        state: '',
                        zipCode: '',
                        country: ''
                    }
                }, function () {
                    _this2.props.handleAddressChange(_this2.state.addAddressObj);
                });
            }
        }
    }, {
        key: 'addInputFieldChange',
        value: function addInputFieldChange(e) {
            var _this3 = this;

            var autocomplete = document.getElementById('autocomplete');

            if (autocomplete.value === "") {

                this.state.addAddressObj.addLine1 = "";

                this.setState({
                    addAddressObj: this.state.addAddressObj
                }, function () {

                    _this3.props.handleAddressChange(_this3.state.addAddressObj);
                });
            }
        }
    }, {
        key: 'getAddressDistance',


        // call the function and get address distance from location
        value: function getAddressDistance(deliveryAddress) {
            var locationDetail = _CartStore2.default.getLocationDetail();
            var origin = void 0;
            if (locationDetail.location) {
                origin = {
                    lat: locationDetail.location.latitude,
                    lng: locationDetail.location.longitude
                };
            } else {
                origin = Utils.getAddressSearchStrFromLocation(locationDetail);
            }
            // call the google API and get distance
            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: [origin], //array of origins
                destinations: [deliveryAddress], //array of destinations
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false
            }, this.callback);
        }
    }, {
        key: 'fillInAddress',
        value: function fillInAddress() {
            var _this4 = this;

            // Get the place details from the autocomplete object.
            var place = this.autocomplete.getPlace();

            var address1 = "";
            var postcode = "";
            var locality = "";
            var state = "";
            var country = "";

            // If we can find the place lets go to it
            if (typeof place.address_components !== 'undefined') {
                // Get each component of the address from the place details,
                // and then fill-in the corresponding field on the form.
                // place.address_components are google.maps.GeocoderAddressComponent objects
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = place.address_components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var component = _step.value;

                        var componentType = component.types[0];

                        switch (componentType) {
                            case "street_number":
                                {
                                    address1 = component.long_name + ' ' + address1;
                                    break;
                                }

                            case "route":
                                {
                                    address1 += component.short_name;
                                    break;
                                }
                            case "postal_code":
                                {
                                    postcode = '' + component.long_name + postcode;
                                    // postcode = `${component.short_name}${postcode}`;
                                    break;
                                }
                            // case "postal_code_suffix": {
                            //     postcode = `${postcode}-${component.long_name}`;
                            //     break;
                            // }
                            case "locality":
                                locality = component.long_name;
                                break;
                            case "administrative_area_level_1":
                                {
                                    state = component.short_name;
                                    break;
                                }
                            case "country":
                                country = component.short_name;
                                break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var addressField = document.getElementById('autocomplete');
                addressField.value = address1 + ", " + locality + ", " + state + ", " + postcode + ", " + country;

                var name = this.state.addAddressObj.name;
                var phoneNo = this.state.addAddressObj.phoneNumber;
                this.setState({
                    addAddressObj: {
                        name: name,
                        phoneNumber: phoneNo,
                        addLine1: address1,
                        addLine2: "",
                        city: locality,
                        state: state,
                        zipCode: postcode,
                        country: country
                    }
                }, function () {

                    // calculate the delivery distance
                    _this4.calculateDistances(_this4.state.addAddressObj);
                });
            } else {

                // set empty delivery address
                this.props.handleAddressChange({});
            }
        }

        // handleSubmit(event) {
        //     event.preventDefault();
        //
        //     console.log("handle submit function");
        //
        //     let sname = this.state.name.replaceAll(/\s+/g, ' ').trim();
        //
        //     // validation
        //     if (Utils.isEmpty(sname)){
        //         this.setState({ error : 'User name is empty.' });
        //         return;
        //     }
        //
        //     // validation
        //     if (Utils.isEmpty(this.state.phoneNumber)) {
        //         this.setState({ error : 'Phone number is empty.' });
        //         return;
        //     }
        //
        //     let phoneNo = Utils.removeNonNumber(this.state.phoneNumber);
        //     // let phoneNo = this.state.phoneNumber;
        //     // validation
        //     if (phoneNo.length !== 10) {
        //         this.setState({ error : 'Phone number must be of 10 Digits.' });
        //         return;
        //     }
        //     // validation
        //     if (Utils.isEmpty(this.state.addLine1)) {
        //         this.setState({ error : 'Address is empty.' });
        //         return;
        //     }
        //
        //     this.setState({isAddressBeingAdd : true});
        //     const formData = {
        //         name        : sname,
        //         addLine1    : this.state.addLine1,
        //         addLine2    : this.state.addLine2,
        //         city        : this.state.city,
        //         state       : this.state.state,
        //         zipCode     : this.state.zipCode,
        //         country     : this.state.country,
        //         phoneNumber : phoneNo
        //     };
        //
        //     // console.log(formData);
        //
        //     const currentUser = Parse.User.current();
        //     currentUser.addUnique("deliveryAddress", formData);
        //     currentUser.save()
        //         .then(
        //             (user) => {
        //                 this.setState({
        //                     name             : '',
        //                     addLine1          : '',
        //                     addLine2          : '',
        //                     city              : '',
        //                     state             : '',
        //                     zipCode           : '',
        //                     phoneNumber       : '',
        //                     country           : '',
        //                     isAddressBeingAdd : false,
        //                     validateAdd       : true,
        //                 }, () => {
        //                     this.props.onAddressSubmit(
        //                         formData
        //                     );
        //
        //                 });
        //             },
        //             (error) => {
        //                 Utils.checkErrorIsInvalidSessionToken(error, '/', false);
        //                 this.setState({
        //                     isAddressBeingAdd : false,
        //                     error  : error.message,
        //                     buttonText:error.message
        //                 });
        //             });
        // }

    }, {
        key: 'changeName',
        value: function changeName(event) {
            var _this5 = this;

            this.state.addAddressObj.name = event.target.value;

            this.setState({
                addAddressObj: this.state.addAddressObj
            }, function () {

                // add check if addressLine1 is not empty then call below function

                if (!Utils.isEmptyObj(_this5.state.addAddressObj) && !Utils.isEmpty(_this5.state.addAddressObj.name)) {
                    _this5.props.handleAddressChange(_this5.state.addAddressObj);
                }
            });
        }
    }, {
        key: 'changeAddressLine2',
        value: function changeAddressLine2(e) {
            var _this6 = this;

            this.state.addAddressObj.addLine2 = e.target.value;

            this.setState({
                addAddressObj: this.state.addAddressObj
            }, function () {

                if (!Utils.isEmptyObj(_this6.state.addAddressObj) && !Utils.isEmpty(_this6.state.addAddressObj.addLine1)) {
                    _this6.props.handleAddressChange(_this6.state.addAddressObj);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this7 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'fieldset',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'col-lg-12 curbside-pickup-instruction form_input_width mb-2' },
                        _react2.default.createElement(
                            'div',
                            { className: ' no-gutter' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'name', className: 'cart-header form-group-label' },
                                'Name'
                            ),
                            _react2.default.createElement('input', {
                                // tabIndex={0}
                                id: 'name',
                                type: 'text',
                                placeholder: 'Name',
                                onChange: this.changeName,
                                name: 'name'
                                // value       = {this.state.name}
                                , value: this.state.addAddressObj.name,
                                className: 'form-control text-secondary-light rounded-sm',
                                title: 'Numbers & Special Characters not Allowed like (@ * . # ! $ ^ &)',
                                pattern: '[ a-zA-Z][ a-zA-Z ]+[ a-zA-Z]$'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: ' no-gutter mt-10' },
                            _react2.default.createElement(
                                'label',
                                { className: 'form-group-label cart-header' },
                                'Phone Number'
                            ),
                            _react2.default.createElement('input', {
                                // tabIndex={1}
                                type: 'tel',
                                placeholder: 'Phone Number',
                                title: 'Phone Number',
                                onChange: function onChange(e) {
                                    return _this7.changePhoneNumber(e);
                                },
                                name: 'phoneNumber',
                                value: this.state.addAddressObj.phoneNumber
                                // value       = { Utils.formatPhoneNumber(this.state.addAddressObj.phoneNumber)}
                                , className: 'form-control text-secondary-light rounded-sm',
                                required: true
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: ' no-gutter mt-10' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'autocomplete', className: 'form-group-label cart-header' },
                                'Search the address on Google'
                            ),
                            _react2.default.createElement('input', { id: 'autocomplete',
                                className: 'input-field form-control text-secondary-light rounded-sm',
                                ref: 'input',
                                type: 'text',
                                placeholder: "Start typing to search address on Google"
                            })
                        ),
                        this.state.addAddressObj.addLine1 ? _react2.default.createElement(
                            'div',
                            { className: ' no-gutter mt-10' },
                            _react2.default.createElement(
                                'label',
                                { htmlFor: 'addLine2', className: 'form-group-label cart-header' },
                                'Apartment, unit, suite, or floor (Optional)'
                            ),
                            _react2.default.createElement('input', {
                                id: 'addLine2',
                                type: 'text',
                                placeholder: 'Apartment, unit, suite, or floor',
                                title: 'Apartment, unit, suite, or floor',
                                onChange: this.changeAddressLine2,
                                name: 'addLine2',
                                value: this.state.addAddressObj.addLine2,
                                className: 'form-control text-secondary-light rounded-sm'

                            })
                        ) : null
                    )
                )
            );
        }
    }]);

    return Address;
}(_react2.default.Component);

exports.default = Address;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/Address.jsx
// module id = 498
// module chunks = 0